module.exports = __webpack_public_path__ + "static/media/IUP_niespar.bc174b9f.svg";